var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--thin onboarding-page",class:{'eoi-form-top-gap': _vm.$route.name === 'eoi'}},[_c('eoi-form',{attrs:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }